<template>
  <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :close-on-backdrop="false" :centered="true" :title="title"
    :size="'lg'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
    <div class="row">
      <div class="col-md-12 col-lg-12 col-xs-12">
        <div id="table-detalle">
          <div class="modal-body">
            <div class="modal-body mr-2 ml-2">
              <CRow>
                <CCol xl="4" lg="4" md="12" sm="12">
                  <CInput label="FECHA DE CITA" type="date" v-model="quote.date" :disabled="isDisabled"/>
                </CCol>
                <CCol xl="4" lg="4" md="12" sm="12">
                  <label>Encargado</label>
                  <v-select v-model="quote.barber"
                    placeholder="Seleccione varias opciones..." label="label"
                    :options="availableBarber" :close-on-select="false" multiple />
                </CCol>
                <CCol xl="4" lg="4" md="12" sm="12">
                  <label>SERVICIOS</label>
                  <v-select v-model="quote.service" :disabled="isDisabled" 
                    placeholder="Seleccione varias opciones..." label="label"
                    :options="availableServices" :close-on-select="false" multiple />
                </CCol>
                <!-- Aquí empieza la tabla de servicios agregada -->
                <CCol sm="12" md="12" lg="12" class="mt-3">
                  <div class="table-responsive">
                    <table class="table table-sm table-hover table-bordered dt-responsive nowrap" style="width: 100%">
                      <thead>
                        <tr>
                          <th width="60">N°</th>
                          <th>Servicio</th>
                          <th>Cantidad</th>
                          <th>Subtotal</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(service, index) in quote.service" :key="service.value">
                          <td>{{ index + 1 }}</td>
                          <td>{{ service.label }} - S/{{ service.price }}</td>
                          <td>
                            <input type="number" class="form-control form-control-sm" v-model.number="service.quantity"
                              min="1" style="width: 80px;" @blur="calculateEndTime" :disabled="isDisabled"/>
                          </td>
                          <td>
                            S/ {{ isNaN(parseFloat(service.quantity) * parseFloat(service.price)) ? '0.00' :
                              (parseFloat(service.quantity) * parseFloat(service.price)).toFixed(2) }}
                          </td>
                          <td>
                            <button class="btn btn-danger btn-sm" @click="removeServiceFromQuote(service.value)" 
                              :disabled="isDisabled">
                              <i class="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </CCol>
                <!-- Aquí termina la tabla -->

                <CCol xl="4" lg="4" md="8" sm="8" class="col-8">
                  <CInput label="Documento" placeholder="Digite documento" v-model="quote.dni"
                    @keypress.enter="mtdDocumentClient" :disabled="isDisabled"/>
                </CCol>
                <CCol xl="2" lg="2" md="4" sm="4" class="my-auto mt-1 col-4">
                  <CButton class="mt-2 w-100" color="info" v-c-tooltip.hover="{ content: `Buscar documento` }"
                    :disabled="isDisabled"
                    @click="mtdDocumentClient">
                    <i class="fas fa-search"></i>
                  </CButton>
                </CCol>
                <CCol xl="6" lg="6" md="12" sm="12">
                  <CInput label="CLIENTE" v-model="quote.client_name" :disabled="isDisabled" />
                </CCol>
                <CCol xl="4" lg="4" md="12" sm="12">
                  <CInput label="HORA DE CITA" type="time" v-model="quote.hour" :disabled="isDisabled"/>
                </CCol>
                <CCol xl="4" lg="4" md="6" sm="6" class="col-6">
                  <CInput label="Total" v-model="quote.total" disabled />
                </CCol>
                <CCol xl="4" lg="4" md="6" sm="6" class="col-6">
                  <CInput label="Adelanto" v-model="quote.advance" placeholder="0.00" disabled/>
                </CCol>
              </CRow>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <button @click="mtdClose(false)" class="btn btn-danger btn-sm">
        <i class="fa fa-times"></i>&nbsp;Cerrar
      </button>
      <button @click="mtdUpdateQuote" class="btn btn-success btn-sm">
        Actualizar
      </button>
    </template>
  </CModal>
</template>

<script>
import CModal from "../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";
import cSelectForm from "../../shared/inputs/cSelect.vue";
import moment from "moment";
import { bus } from "../../../main";

export default {
  name: "c-updatequote-modal",
  components: {
    CModal,
    cSelectForm,
  },
  data() {
    return {
      swal: null,
      quote: {
        id: "",
        // barber_id: "",
        // barber_name: "",
        campu_id: this.$store.getters.get_campu.id,
        company_id: this.$store.getters.get_company.id,
        end_hour: "",
        hour: "",
        date: "",
        dni: "",
        client_name: "",
        phone: "",
        client_id: "",
        service: [],
        barber: [],
        total: 0.00,
        advance: 0.00,
        validationCrossing: true,
      },
      data_barbers: [],
      data_services: [],
    }
  },
  props: {
    title: String,
    boo_modal: Boolean,
    id: Number,
    state: Number,
  },
  computed: {
    availableServices() {
      const selectedServiceIds = this.quote.service.map(service => service.value);
      this.quote.total = this.quote.service
        .filter(service => selectedServiceIds.includes(service.value))
        .reduce((total, service) => total + (service.price * service.quantity), 0);

      return this.data_services.filter(service => !selectedServiceIds.includes(service.value));
    },
    availableBarber() {
      const selectedBarberIds = this.quote.barber.map(barber => barber.value);
      return this.data_barbers.filter(barber => !selectedBarberIds.includes(barber.value));
    },
    isDisabled() {
      return Number(this.state) === 3;
    },
  },
  watch: {
    'quote.service': function (newServices) {
      // this.calculateEndTime();
      newServices.forEach(service => {
        if (!service.hasOwnProperty('quantity')) {
          this.$set(service, 'quantity', 1);
        }
      });
    },
    boo_modal(newVal) {
      if (newVal) {
        this.mtd_show();
        this.byBarber();
        this.byServices();
      }
    },
    quote: {
      handler(newVal) {
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose(refresh) {
      this.quote = {
        id: "",
        // barber_id: "",
        // barber_name: "",
        campu_id: this.$store.getters.get_campu.id,
        company_id: this.$store.getters.get_company.id,
        end_hour: "",
        hour: "",
        date: "",
        dni: "",
        client_name: "",
        phone: "",
        client_id: "",
        barber: [],
        service: [],
        total: "",
        advance: "",
        validationCrossing: true,
      };
      this.$emit("closeModalUpdateQuote", refresh);
    },

    calculateEndTime() {
      let totalMinutes = 0;
      this.quote.service.forEach(service => {
        const serviceTime = moment.duration(service.time);
        totalMinutes += serviceTime.asMinutes();
      });

      if (this.quote.hour) {
        const startTime = moment(this.quote.date + ' ' + this.quote.hour, 'YYYY-MM-DD HH:mm:ss');
        const endTime = startTime.add(totalMinutes, 'minutes');
        this.quote.end_hour = endTime.format('HH:mm:ss');
      }
    },

    mtd_show: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/cita/" +
          this.$props.id +
          "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.quote.id = response.id;
          this.quote.date = response.date;
          this.quote.end_hour = response.end_hour;
          this.quote.hour = response.hour;
          // this.quote.barber_id = response.barber_id;
          this.quote.client_id = response.client_id;
          this.quote.dni = response.client.document;
          this.quote.client_name = response.client.name;
          this.quote.phone = response.client.phone;
          this.quote.advance = parseFloat(response.advance_payment);
          this.quote.service = response.detail.map(element => ({
            value: element.service.id,
            label: element.name_service,
            time: element.service.time,
            price: parseFloat(element.service.price),
            quantity: element.quantity,
          }));

          this.quote.barber = response.barber_detail.map(element => ({
            value: element.barber.id,
            label: `${element.barber.name} ${element.barber.last_name}`,
          }));
          this.calculateEndTime();
        })
        .catch((errors) => { });
    },
    byBarber: function () {
      this.get({
        url: this.$store.getters.get__url + '/cita/byBarber/' + this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        this.data_barbers = [];
        response.data.data.forEach(element => {
          this.data_barbers.push({
            value: element.id,
            label: `${element.name} ${element.last_name}`,
          })
        });
      }).catch((errors) => { });
    },
    byServices: function () {
      this.get({
        url: this.$store.getters.get__url + '/cita/byServices/' + this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        this.data_services = [];
        response.data.data.forEach(element => {
          this.data_services.push({
            value: element.id,
            label: element.name,
            time: element.time,
            price: parseFloat(element.price),
          })
        });
      }).catch(() => { });
    },
    mtdDocumentClient: function () {
      if(this.quote.dni.length === 9){
        this.mtdSearchClientByCE();
        return;
      }

      this.get({
        url:
          this.$store.getters.get__url +
          "/cita/cliente/" + this.$store.getters.get_company.id + "/" +
          this.quote.dni,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.data.state === 0) {
          if (this.quote.dni.length === 8 || this.quote.dni.length === 11) {
            this.mtdSearchDocument();
          } else {
            this.quote.client_name = "";
          }
        } else if (response.statusCode === 200 && response.data.state === 1) {
          this.quote.client_name = response.data.data.name;
        }
      });
    },
    mtdSearchClientByCE(){
      this.get({
        url: `${this.$store.getters.get__url}/Consultas/searchCe/${this.quote.dni}`,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if(response.statusCode !== 200){
            Swal.fire({
              title: "Documento no encontrado",
              icon: "warning",
            });
            this.quote.client_name = "";
            return;
          }

          this.quote.client_name = response.data.name;
        });
    },
    /*mtdSearchDocument: function () {
      if (this.quote.dni.length == 8) {
        this.get({
          url: this.$store.getters.get__url + "/Consultas/" + this.quote.dni,
          token: this.$store.getters.get__token,
        }).then((response) => {
          if (response.data.boo == 3) {
            Swal.fire({
              title: "DNI no encontrado",
              icon: "warning",
            });
          } else {
            this.quote.client_name = response.data.name + " " + response.data.last_name;
          }
        });
      }
    },*/
    mtdSearchDocument: function () {
      if (this.quote.dni.length !== 8 && this.quote.dni.length !== 11) {
        Swal.fire({
          title: "Documento inválido",
          icon: "error",
        });
        return;
      }

      this.get({
        url:
          this.$store.getters.get__url +
          "/Consultas/" +
          this.quote.dni,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.data.boo === 3) {
            this.clearClientData();
            Swal.fire({
              title: "Documento no encontrado",
              icon: "warning",
            });
          } else {
            this.populateClientData(response.data);
          }
        })
        .catch((error) => {
          console.error("Error al consultar el documento:", error);
          Swal.fire({
            title: "Error en la solicitud",
            text: "Por favor, intente nuevamente más tarde.",
            icon: "error",
          });
        });
    },

    clearClientData: function () {
      this.quote.client_name = "";
      this.quote.client_address = "";
    },

    populateClientData: function (data) {
      if (this.quote.dni.length === 8) {
        this.quote.client_name = `${data.name} ${data.last_name}`;
      } else {
        this.quote.client_name = data.razon_social;
      }
      this.quote.client_address = data.direccion;
    },
    mtdUpdateQuote() {
      if (!this.validationTotal()) {
        return;
      }
      if (
        this.quote.date &&
        this.quote.barber.length > 0 &&
        this.quote.service.length > 0 &&
        this.quote.client_name
      ) {
        this.post({
          url: this.$store.getters.get__url + "/cita/update",
          token: this.$store.getters.get__token,
          params: this.quote,
        })
          .then((response) => {
            if (response.data.existe == 1) {
              Swal.fire({
                title: `Ya existe una cita en ese horario con algún encargado con
                      ${response.data.existingQuote[0].barber_detail[0].barber.name} ${response.data.existingQuote[0].barber_detail[0].barber.last_name}`,
                icon: "warning",
                text: "¿Desea registrar igualmente?",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, Registrar!",
                cancelButtonText: "Cancelar",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.quote.validationCrossing = false;
                  this.mtdUpdateQuote();
                }
              });
            } else {
              let color = "";
              let message = "";
              if (response.statusCode == 200) {
                color = "success";
                message = "REGISTRADO CORRECTAMENTE";
              } else {
                color = "danger";
                message = "error";
              }
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Reserva Editada",
                showConfirmButton: false,
                timer: 1500,
              });
              this.mtdClose(true);
            }
          })
          .catch((errors) => {
            Swal.fire({
              title: errors,
              icon: "danger",
            });
          });
      } else {
        Swal.fire({
          icon: "error",
          title: "Complete todos los campos!",
        });
      }
    },
    validationTotal() {
      if (parseFloat(this.quote.total) < parseFloat(this.quote.advance)) {
        Swal.fire({
          title: "El adelanto no puede ser mayor que el total.",
          icon: "warning",
        });
        return false; // Detiene el flujo
      }
      return true; // Continúa si no hay error
    },
    removeServiceFromQuote(serviceId) {
      this.quote.service = this.quote.service.filter(service => service.value !== serviceId);
    },
  }
}
</script>

<style scoped>
.bg-purple {
  background-color: #00003a;
}

.color-white {
  color: white;
}
</style>
